import { inject } from 'vue';

/** createAxApp 과 동일한 provide 키 */
export const DEPLOYMENT_MODE_KEY = 'deploymentMode' as const;

/** 로그인 폼에 채워 넣을 기본 테넌트 코드 (createAxApp 이 provide) */
export const LOGIN_DEFAULT_TENANT_CODE_KEY = 'loginDefaultTenantCode' as const;

/** 회사정보관리 화면의 Google 캘린더 연동 섹션 노출 여부 (ERP 전용). createAxApp 이 provide */
export const COMPANY_GOOGLE_CALENDAR_ENABLED_KEY = 'companyGoogleCalendarEnabled' as const;

/** 회사정보관리의 Google 캘린더 연동 노출 여부. 미주입(MES 등)이면 false → 숨김. */
export function useCompanyGoogleCalendarEnabled(): boolean {
  return inject<boolean>(COMPANY_GOOGLE_CALENDAR_ENABLED_KEY, false);
}

/** 회사정보관리의 스마트해썹(sHACCP) 기능 토글 노출 여부. createAxApp 이 provide */
export const COMPANY_SMART_HACCP_TOGGLE_ENABLED_KEY = 'companySmartHaccpToggleEnabled' as const;

/**
 * 회사정보관리의 스마트해썹 사용여부 토글 노출.
 * 스마트해썹은 식품제조 MES 전용 기능이라 ERP 등에는 해당 없음.
 * 미주입/기본은 true(하위호환 — 기존 MES 동작 유지), ERP 만 false 로 숨긴다.
 */
export function useCompanySmartHaccpToggleEnabled(): boolean {
  return inject<boolean>(COMPANY_SMART_HACCP_TOGGLE_ENABLED_KEY, true);
}

export type DeploymentMode = 'saas' | 'on-prem';

/**
 * 부트스트랩 시 주입된 배포 모드.
 * provide 가 없으면 `VITE_DEPLOYMENT_MODE` → 최종 폴백 `saas`.
 */
export function useDeploymentMode(): DeploymentMode {
  const injected = inject<DeploymentMode | undefined>(DEPLOYMENT_MODE_KEY, undefined);
  if (injected === 'saas' || injected === 'on-prem') {
    return injected;
  }
  const env = import.meta.env.VITE_DEPLOYMENT_MODE;
  return env === 'on-prem' ? 'on-prem' : 'saas';
}
